import { ColumnHelper } from "@tanstack/react-table";
import { ActionType } from "PFApp/hooks/activity_form/multi_roles_form/use_actions_column";
import css from "PFApp/hooks/activity_form/multi_roles_form/use_actions_column/actions_cell.module.scss";
import { RoleFormKey } from "PFApp/types/activity_form/activity_form_schema";
import { useCallback } from "react";

import { ManageRolesActionsCell } from "../parts/manage_roles_actions_cell";

type UseManageRolesActionsColumnProps = {
  roleFormKeys: RoleFormKey[];
  onChange: (roleFormKey: RoleFormKey, action: ActionType) => void;
  actionsBlacklist?: ActionType[];
};

export const useManageRolesActionsColumn = <DATA extends object>({
  roleFormKeys,
  onChange,
  actionsBlacklist
}: UseManageRolesActionsColumnProps) =>
  useCallback(
    (columnHelper: ColumnHelper<DATA>) =>
      columnHelper.accessor((row) => row, {
        id: "actions",
        header: "",
        cell: (info) => (
          <ManageRolesActionsCell
            roleFormKey={roleFormKeys[info.row.index]}
            onChange={onChange}
            actionsBlacklist={actionsBlacklist}
          />
        ),
        size: 32,
        enableSorting: false,
        meta: {
          sticky: true,
          cellClassName: css.actionsCell
        }
      }),
    [onChange, actionsBlacklist, roleFormKeys]
  );
